import { render } from "./footer.vue?vue&type=template&id=67a5afae&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=67a5afae&scoped=true&lang=scss"

import exportComponent from "E:\\object\\源制汇产能共享公共服务平台\\boyaokj-enyuan-yuanliancloud-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a5afae"]])

export default __exports__